import {
  Button,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { getGenericPaymentMethods } from "../../../../../../features/generic-data";

import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FilteredPaymentOptions from "./filtered-payment-section";
import { isEmpty } from "lodash";
import { setPaymentMethods } from "../../../../../../store/actions/pay-for-ad";

import { CHECKOUT_OPTIONS } from "../../../../../../static-data";
import CheckoutOptionCard from "./checkout-option-card";
import "../../../style.css";
import { PAYMENT_TYPES, SUPPORTED_CURRENCIES } from "../../../../../../config/constant";

const PaymentSection = () => {
  const [selectedPaymentOption, setSelectedPaymentOption] = useState();
  const [displayFilteredOptions, setDisplayFilteredOptions] = useState(false);
  const [error, setError] = useState("");

  const recurringPayment = sessionStorage.getItem(PAYMENT_TYPES.IS_RECURRING) === "true";

  const {
    loadingInvoiceData,
    paymentMethods,
  } = useSelector((state) => state.payForAd);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedCurrency = sessionStorage.getItem("checkout_currency");
  const isMobileView = useMediaQuery(
    "(max-width:700px)"
  );

  useEffect(() => {
    // stripe
    const stripeScript = document.createElement("script");
    stripeScript.src = "https://js.stripe.com/v3/";
    stripeScript.async = true;

    document.body.appendChild(stripeScript);

    // paypal
    const paypalScript = document.createElement("script");

    paypalScript.src = "https://www.paypalobjects.com/api/checkout.js";
    paypalScript.async = true;

    document.body.appendChild(paypalScript);
  }, []);

  useEffect(() => {
    if (isEmpty(paymentMethods)) {
      getGenericPaymentMethods()
        .then((result) => {
          if (result.success) {
            dispatch(setPaymentMethods(result.body));
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });
    }
  }, [dispatch, paymentMethods]);

  useEffect(() => {
    setError("");
  }, [selectedPaymentOption]);

  return (
    <Grid
      id="payment-methods-div"
      className="payment-options-view"
      container
      direction="column"
      style={{
        rowGap: 24,
        width: isMobileView ? "100%" : "48%",
        padding: isMobileView ? 0 : "0 16px",
      }}
    >
      {displayFilteredOptions ? (
        <FilteredPaymentOptions
          selectedMethod={selectedPaymentOption}
          setDisplayFilteredOptions={setDisplayFilteredOptions}
        />
      ) : (
        <>
          <Grid
            container
            direction="column"
            className="payment-options-list-view"
          >
            <Typography variant="body2">
              {t("payment.PaymentOptions")}
            </Typography>
            <Grid container style={{ columnGap: 8, rowGap: 8 }}>
              {CHECKOUT_OPTIONS.filter((element) =>
                recurringPayment
                  ? element.recurringAllowed
                  : true && selectedCurrency === SUPPORTED_CURRENCIES.USD
                  ? element.id !== "other"
                  : true
              ).map((element) => (
                <CheckoutOptionCard
                  id={element.id}
                  optionInfo={element}
                  selectedPaymentOption={selectedPaymentOption}
                  setSelectedPaymentOption={setSelectedPaymentOption}
                />
              ))}
            </Grid>
          </Grid>

          {error && (
            <Typography variant="caption" className="continue-error-txt">
              {error}
            </Typography>
          )}

          <Button
            id="make-payment-btn"
            className="payment-continue-btn"
            disabled={loadingInvoiceData}
            onClick={() =>
              selectedPaymentOption
                ? setDisplayFilteredOptions(true)
                : setError(t("payment.selectPaymentMethodToCotinue"))
            }
          >
            {loadingInvoiceData ? (
              <CircularProgress size={20} />
            ) : (
              t("post.continue")
            )}
          </Button>
        </>
      )}
    </Grid>
  );
};

export default PaymentSection;
